import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c1ded16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plugin-page" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      src: `/plugins/${_ctx.plugin?.PluginIndexUrl}`
    }, null, 8, _hoisted_2)
  ]))
}